import { useEffect, useState } from "react";
import Modal from "../../components/Modal";
import { useLocation, useNavigate } from "react-router-dom";
import Api from "../../utils/api";

const ERROR_MSG =
  "Se produjo un error en la acción solicitada, por favor intente realizar la operación nuevamente.";

export const CuotasYPagoResultado = () => {
  const { search } = useLocation();
  const navigate = useNavigate();

  const [isLoaging, setIsLoading] = useState(true);
  const [message, setMessage] = useState("Cargando...");

  useEffect(() => {
    const searchParams = new URLSearchParams(search);

    // MercadoPago vuelve con estos params; Decidir vuelve con `result`.
    const esMercadoPago =
      searchParams.has("collection_id") ||
      searchParams.has("payment_id") ||
      searchParams.has("preference_id") ||
      (searchParams.get("external_reference") || "").startsWith("MP_");

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const finalizar: Promise<any> = esMercadoPago
      ? (() => {
          // finMercadoPago espera todos los params como result=<base64(json)>
          const query: { [index: string]: string } = {};
          Array.from(searchParams.keys()).forEach((key) => {
            query[key] = searchParams.get(key) ?? "";
          });
          const queryString = btoa(JSON.stringify(query));
          return Api("finMercadoPago", undefined, "result=" + queryString)
            .post()
            .then((res) => res?.mensaje ?? res?.mensaje?.descripcion);
        })()
      : Api("consumirST")
          .post({
            servicio: "pagarDecidirFin",
            param: { prm_result: searchParams.get("result") },
          })
          .then((res) => res?.mensaje?.descripcion ?? res?.mensaje);

    finalizar
      .then((msg) => setMessage(msg || ERROR_MSG))
      .catch((err) => {
        console.error("[pagoResultado] error finalizando pago", err);
        setMessage(ERROR_MSG);
      })
      .finally(() => setIsLoading(false));
  }, [search]);

  return (
    <div>
      <Modal
        onLoadAceptar={isLoaging}
        hideClose={true}
        btnAceptar="Aceptar"
        onAceptar={() => navigate("/")}
        title="Detalle del Pago"
        onClose={() => {}}
        show={true}
      >
        <p dangerouslySetInnerHTML={{ __html: message }}></p>
      </Modal>
    </div>
  );
};
